import {AccountTypeName, GaapType} from "@app/shared";

export class Account {
  id: number;
  accountNumber: number;
  accountName: string;
  accountDescription: string;
  children?: Account[];
}

export class AccountType {
  id?: number;
  version?: number;
  name: AccountTypeName;
  description: string;
  orgId: number;
  gaapType: GaapType;
}
